import React, { useEffect, useRef } from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { landingPageMetaProps } from '../../util/misc';
import { LayoutComposer, NamedLink, LandingPagesSubFooter, CustomerListingCard, IconSpinner } from '../../components';
import { parse } from '../../util/urlHelpers';

import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';
import StaticPage from '../PageBuilder/StaticPage';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { getListingsById } from '../../ducks/marketplaceData.duck';

import { ReactComponent as RightArrowIcon } from '../../assets/landingAssets/rightArrow.svg';
import { ReactComponent as GemIcon } from '../../assets/landingAssets/gem.svg';
import { ReactComponent as BagIcon } from '../../assets/landingAssets/bag.svg';
import { ReactComponent as ShipIcon } from '../../assets/landingAssets/ship.svg';
import { ReactComponent as LockIcon } from '../../assets/landingAssets/lock.svg';
import { ReactComponent as BuildCircleIcon } from '../../assets/landingAssets/buildCircle.svg';
import { ReactComponent as WorkHistoryIcon } from '../../assets/landingAssets/workHistory.svg';
import { ReactComponent as WorkHistoryIconLarge } from '../../assets/landingAssets/workHistoryLarge.svg';
import { ReactComponent as ArrowRightIcon } from '../../assets/landingAssets/arrowRight.svg';

import customerPageWhyImage from '../../assets/landingAssets/newMainBG.png';
import xLogo from '../../assets/landingAssets/logoX.png';

import css from './CustomerLandingPage.module.css';

const CustomerLandingPageComponent = props => {
    const { listings, pagination, searchInProgress, searchListingsError, location, searchParams, currentUser } = props;

    const queryParams = parse(location.search);
    const activeTab = queryParams.tab || 'loose-emeralds';
    const listingsRef = useRef(null);
    const isFirstRender = useRef(true);


    useEffect(() => {
        if (!isFirstRender.current) {
            setTimeout(() => {
                listingsRef.current?.scrollIntoView({ behavior: 'auto' });
            }, 0);
        } else {
            isFirstRender.current = false;
        }
    }, [location.key]);




    const isLoose = activeTab === 'loose-emeralds';
    const isJewelry = activeTab === 'emerald-jewelry';

    const containerStyle = isJewelry ? css.jewelryContainer : css.listingsContainer;
    const activeTabClass = isJewelry ? css.jewelryTabActive : css.looseTabActive;
    const layoutAreas = `
    topbar
    main
    footer
  `;

    const pageMetaProps = landingPageMetaProps;

    return <StaticPage {...pageMetaProps}>
        <LayoutComposer areas={layoutAreas} className={css.layout}>
            {props => {
                const { Topbar, Main, Footer } = props;
                return <>
                    <Topbar as="header" className={css.topbar}>
                        <TopbarContainer currentPage="LandingPage" />
                    </Topbar>
                    <Main as="main" className={css.main}>
                        <div className={css.hero}>
                            <div className={css.innerHero}>
                                <div className={css.smallTitle}>
                                    <FormattedMessage id="CustomerLandingPage.smallTitle" />
                                </div>
                                <h1 className={css.title}>
                                    <FormattedMessage id="CustomerLandingPage.title" />
                                </h1>
                                <div className={css.subTitle}>
                                    <FormattedMessage id="CustomerLandingPage.subTitle" />
                                </div>
                                <div className={css.cta}>
                                    <NamedLink name="SignupPage" className={css.exploreCta}>
                                        <FormattedMessage id="CustomerLandingPage.exploreCta" />
                                        <RightArrowIcon />
                                    </NamedLink>
                                    {/* <NamedLink name="LandingPage" className={css.designCta}>
                                        <FormattedMessage id="CustomerLandingPage.designCta" />
                                        <RightArrowIcon className={css.desktopOnly} />
                                    </NamedLink> */}
                                </div>

                                <h3 className={css.gemExpTitle}>
                                    <img src={xLogo} className={css.xLogo} /> <FormattedMessage id="CustomerLandingPage.gemExpTitle" />
                                </h3>
                                <div className={css.gemExps}>
                                    <div className={css.gemExp}>
                                        <GemIcon />
                                        <div className={css.gemExpLabel}>
                                            <FormattedMessage id="CustomerLandingPage.gemExpLabel1" />
                                        </div>
                                        <div className={css.gemExpText}>
                                            <FormattedMessage id="CustomerLandingPage.gemExpText1" />
                                        </div>
                                    </div>
                                    <div className={css.gemExp}>
                                        <BagIcon />
                                        <div className={css.gemExpLabel}>
                                            <FormattedMessage id="CustomerLandingPage.gemExpLabel2" />
                                        </div>
                                        <div className={css.gemExpText}>
                                            <FormattedMessage id="CustomerLandingPage.gemExpText2" />
                                        </div>
                                    </div>
                                    <div className={css.gemExp}>
                                        <ShipIcon />
                                        <div className={css.gemExpLabel}>
                                            <FormattedMessage id="CustomerLandingPage.gemExpLabel3" />
                                        </div>
                                        <div className={css.gemExpText}>
                                            <FormattedMessage id="CustomerLandingPage.gemExpText3" />
                                        </div>
                                    </div>
                                    <div className={css.gemExp}>
                                        <LockIcon />
                                        <div className={css.gemExpLabel}>
                                            <FormattedMessage id="CustomerLandingPage.gemExpLabel4" />
                                        </div>
                                        <div className={css.gemExpText}>
                                            <FormattedMessage id="CustomerLandingPage.gemExpText4" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className={css.whyColombian}>
                            <div className={css.whyColombianImg}>
                                <img src={customerPageWhyImage} />
                            </div>
                            <div className={css.whyColombianContent}>
                                <div className={css.whyColombianTitle}>
                                    <FormattedMessage id="CustomerLandingPage.whyColombianTitle" />
                                </div>
                                <div className={css.whyColombianText}>
                                    <FormattedMessage id="CustomerLandingPage.whyColombianText" />
                                </div>
                                <NamedLink name="SignupPage" className={css.whyColombianCta}>
                                    <FormattedMessage id="CustomerLandingPage.whyColombianCta" />
                                </NamedLink>
                            </div>
                        </div>
                        {/* <div className={css.collectionsSection} ref={listingsRef}>
                            <div className={css.collectionsSectionTitle}>
                                <FormattedMessage id="CustomerLandingPage.collectionsSectionTitle" />
                            </div>
                            <div className={css.listingsSection}>
                                <div className={css.listingsTabs}>
                                    <NamedLink
                                        name="CustomerLandingPage"
                                        // search="?tab=loose-emeralds"
                                        to={{ search: "?tab=loose-emeralds" }}
                                        className={`${css.tab} ${isLoose ? css.looseTabActive : css.looseTab}`}
                                    >
                                        <FormattedMessage id="CustomerLandingPage.tab1" />
                                    </NamedLink>
                                    <NamedLink
                                        name="CustomerLandingPage"
                                        to={{ search: "?tab=emerald-jewelry" }}
                                        className={`${css.tab} ${isJewelry ? css.jewelryTabActive : css.jewelryTab}`}
                                    >
                                        <FormattedMessage id="CustomerLandingPage.tab2" />
                                    </NamedLink>

                                </div>
                                <div className={containerStyle}>
                                    <div className={css.listingsContainerHeader}>
                                        <div className={css.mobileTitle}>
                                            {isJewelry ? 'Emerald Jewellery' : 'Loose Emeralds'}
                                        </div>
                                        <div className={css.mobileTextInfo}>
                                            {isJewelry
                                                ? 'Discover handcrafted emerald jewellery from our partner jewelers. Each piece is a work of art, combining Colombian emeralds with expert craftsmanship. Custom designs available.'
                                                : 'Explore Colombian emeralds direct from source. Perfect for custom jewellery designs and investment. Each stone is carefully selected and certified for quality.'}
                                        </div>
                                        <div className={css.desktopInfoWrapper}>
                                            <div className={css.desktopTitle}>
                                                {isJewelry ? 'Emerald Jewellery' : 'Loose Emeralds'}
                                            </div>
                                            <div className={css.desktopTextInfo}>
                                                {isJewelry
                                                    ? 'Discover handcrafted emerald jewellery from our partner jewelers. Each piece is a work of art, combining Colombian emeralds with expert craftsmanship. Custom designs available.'
                                                    : 'Explore Colombian emeralds direct from source. Perfect for custom jewellery designs and investment. Each stone is carefully selected and certified for quality.'}
                                            </div>
                                        </div>
                                        <div className={css.desktopIcon}>
                                            {isJewelry ? <WorkHistoryIconLarge /> : <BuildCircleIcon />}
                                        </div>

                                    </div>
                                    <div className={css.listings}>
                                        {searchInProgress ? <IconSpinner className={css.spinner} /> : listings.map(l => (
                                            <div key={l.id.uuid} className={css.listingCard}>
                                                <CustomerListingCard listing={l} currentUser={currentUser} isJewelry={isJewelry} />
                                            </div>
                                        ))}
                                        {searchListingsError && <p className={css.error}>{searchListingsError}</p>}
                                    </div>
                                    {currentUser ? null : <div className={css.accountRequired}>
                                        <div className={css.accountRequiredLeft}>
                                            <WorkHistoryIcon />
                                            <div className={css.accountRequiredTextWrapper}>
                                                <div className={css.accountRequiredTitle}>
                                                    <FormattedMessage id="CustomerLandingPage.accountRequiredTitle" />
                                                </div>
                                                <div className={css.accountRequiredText}>
                                                    <FormattedMessage id="CustomerLandingPage.accountRequiredText" />
                                                </div>
                                            </div>
                                        </div>
                                        <NamedLink name="SignupPage" className={css.accountRequiredCta}>
                                            <FormattedMessage id="CustomerLandingPage.accountRequiredCta" />
                                            <ArrowRightIcon />
                                        </NamedLink>
                                    </div>}
                                </div>


                            </div>
                        </div> */}
                        <div className={css.readyToFindSection}>
                            <div className={css.readyToFindContent}>
                                <div className={css.readyToFindTextWrapper}>
                                    <div className={css.readyToFindTitle}>
                                        <FormattedMessage id="CustomerLandingPage.readyToFindTitle" />
                                    </div>
                                    <div className={css.devider}></div>
                                    <div className={css.readyToFindText}>
                                        <FormattedMessage id="CustomerLandingPage.readyToFindText" />
                                    </div>
                                </div>
                                <NamedLink name="SignupPage" className={css.readyToFindCta}>
                                    <FormattedMessage id="CustomerLandingPage.readyToFindCta" />
                                </NamedLink>
                            </div>
                        </div>
                    </Main>
                    <Footer>
                        <div className={css.subFooterWrapper}>
                            <LandingPagesSubFooter mode="light" />
                        </div>
                        <FooterContainer />
                    </Footer>
                </>
            }}
        </LayoutComposer>
    </StaticPage>
};
const mapStateToProps = state => {
    const { currentUser } = state.user;
    const {
        currentPageResultIds,
        pagination,
        searchParams,
        searchInProgress,
        searchListingsError,

    } = state.CustomerLandingPage;
    const listings = getListingsById(state, currentPageResultIds);

    return {
        currentUser,
        listings,
        pagination,
        // scrollingDisabled: isScrollingDisabled(state),
        searchInProgress,
        searchListingsError,
        searchParams,
    };
};

const mapDispatchToProps = dispatch => ({
    //   onManageDisableScrolling: (componentId, disableScrolling) =>
    //     dispatch(manageDisableScrolling(componentId, disableScrolling)),
});

const CustomerLandingPage = compose(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )
)(CustomerLandingPageComponent);

export default CustomerLandingPage;
